import { useMemo } from 'react';
import { Layers } from 'three';

import { useDollhouse } from '@spazious/dollhouse-engine';
import { DOLLHOUSE_LAYER_INTERACTIVE } from '@spazious/dollhouse-three';

import { useSceneObjects } from './useSceneObjects.js';

/**
 * Get all interactive objects in the scene,
 */
export const useInteractiveObjects = (layer: number | Layers = DOLLHOUSE_LAYER_INTERACTIVE) => {
  const scene = useDollhouse(({ scene }) => scene);

  const layers = useMemo(() => {
    if (layer instanceof Layers) {
      return layer;
    }
    const layers = new Layers();
    layers.set(layer);
    return layers;
  }, [layer]);

  return useSceneObjects(
    scene,
    (node) =>
      node.layers.test(layers) &&
      // Workaround to avoid adding instances to the interactive objects
      !(node as any).isInstances &&
      !(node as any).isInstancedMesh,
    [layers]
  );
};

export default useInteractiveObjects;
